/** The search hub: chips, section titles, rows, empty states. */
export default {
  search: "Search",
  searchAll: "Search everything",
  searchChats: "Search chats",
  searchNotifications: "Search notifications",
  searchTasks: "Search tasks",
  searchFrames: "Search frames",
  searchMemory: "Search memory",
  searchSettings: "Search settings",
  chipAll: "All",
  chats: "Chats",
  notifications: "Notifications",
  tasks: "Tasks",
  frames: "Frames",
  memory: "Memory",
  projects: "Projects",
  agents: "Agents",
  settings: "Settings",
  showResultsFor: "Show results for",
  allProjects: "All projects",
  taskBlocked: "Blocked",
  taskInProgress: "In progress",
  taskInReview: "Ready for review",
  taskTodo: "To do",
  taskBacklog: "Backlog",
  taskDone: "Done",
  recent: "Recent",
  results: "Results",
  running: "Running",
  today: "Today",
  earlier: "Earlier",
  runningNow: "running now",
  unassigned: "Unassigned",
  showAll: "Show all {count}",
  archivedChats: "Archived chats",
  loading: "Loading…",
  loadMore: "Load more",
  actionsFor: "Actions for {title}",
  stopGenerating: "Stop generating",
  rename: "Rename…",
  unarchive: "Unarchive",
  archive: "Archive",
  renameChat: "Rename chat",
  chatName: "Chat name",
  renameFailed: "Couldn’t rename this chat. Please try again.",
  noMatch: "Nothing matches “{query}”.",
  onlyLookingIn: "You’re only looking in {project}.",
  tryOtherWords: "Try fewer or different words.",
  lookInAllProjects: "Look in all projects",
  caughtUp: "You’re all caught up.",
  caughtUpLine:
    "When something needs you, Denker tells you out loud and it waits here.",
  nothingYet: "Nothing here yet.",
  typeToSearchMemory: "Type to search what Denker remembers.",
  memorySearchFailed: "Couldn’t search memory. Try again.",
  workspaceSearchFailed: "Couldn’t search the workspace. Try again.",
} as const;
